import React, { useEffect, useMemo, useState } from "react";
import { Select, message } from "antd";
import { bg_button } from "constant/css";
import { useMerchant } from "context/merchantContext";

const ENVIRONMENTS = {
  test: "https://apitest.esukh.mn",
  prod: "https://api.esukh.mn",
};
const ENVIRONMENTS_XPAY = {
  test: "https://apispay.esukh.mn",
  prod: "https://apispay.esukh.mn",
};

const billingEndpoints = {
  title: "Хэрэглэгчдийн төлбөрийн мэдээллийг авах, баталгаажуулах, төлөх API",
  docUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/%D0%A1%D0%BC%D0%B0%D1%80%D1%82%D0%B1%D0%B8%D0%BB%D0%BB%D0%B8%D0%BD%D0%B3_doc_V2.postman_collection.json",
  envUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/esukh_v2_test.postman_environment.json",
  baseUrl: ENVIRONMENTS,
  endPoints: [
    {
      title: "Login",
      method: "POST",
      path: "/api/v1/billing/partner/login",
      desc: "Нэвтрэх нэр, нууц үг ашиглан токэн авна.",
      body: `{
  "username": "MERCHANT_1",
  "password": "MERCHANT_SECRET"
}`,
    },
    {
      title: "Refresh Token",
      method: "POST",
      path: "/api/v1/billing/partner/refresh_token",
      desc: "refresh_token ашиглан дахин богино токэн авна.",
      body: `{
  "refresh_token": "eyJhbGciOiJIUzI1NiIs..."
}`,
    },
    {
      title: "User OTP",
      method: "POST",
      path: "/api/v1/billing/user/otp",
      desc: "Утасны дугаараар OTP илгээх.",
      body: `{
  "phone": "86963023"
}`,
    },
    {
      title: "Check OTP & get TOKEN",
      method: "POST",
      path: "/api/v1/billing/user/otp/check",
      desc: "OTP код шалгаж токэн авна.",
      body: `{
  "phone": "86963023",
  "code": 8383
}`,
    },
    {
      title: "Get user bills",
      method: "POST",
      path: "/api/v1/billing/user/bills",
      desc: "user_token ашиглан хэрэглэгчийн бүх билл лавлах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Get user bills count by property",
      method: "POST",
      path: "/api/v1/billing/user/bills/count",
      desc: "ҮХХ дээрх идэвхтэй билл тоо авах.",
      body: `{
  "user_token": "{{user_token}}",
  "properties": [1897]
}`,
    },
    {
      title: "Get user bill by property",
      method: "POST",
      path: "/api/v1/billing/user/bills/byProperty/:propertyId",
      desc: "Нэг ҮХХ дээрх билл авах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Bill set paid",
      method: "POST",
      path: "/api/v1/billing/user/bills/paid",
      desc: "Билл төлөлт бүртгэх.",
      body: `{
  "refId": 123,
  "paymentInvoices": [
    {
      "invoiceId": 4000895,
      "amount": 100
    }
  ],
  "user_token": "{{user_token}}"
}`,
    },
    {
      title: "Get VAT",
      method: "POST",
      path: "/api/v1/billing/user/bills/:id/vat",
      desc: "Төлсөн билл-ийн НӨАТ авах.",
      body: `{
  "user_token": "{{user_token}}"
}`,
    },
  ],
};

const xPayEndpoints = {
  title: "Хялбараар төлбөр хүлээн авах API",
  docUrl:
    "https://storage.googleapis.com/smartbilling_hubilai/documents/smartpay_doc_create.postman_collection.json",
  baseUrl: ENVIRONMENTS_XPAY,
  intro: {
    summary:
      "Энэхүү гарын авлага нь Smartpay системээр төлбөр хүлээн авах интеграцид зориулагдсан. Эхлээд мерчантаар нэвтэрч JWT токэн авна, дараа нь тухайн токэноор нэхэмжлэл үүсгэх болон төлөв шалгах хүсэлтүүдийг илгээнэ.",
    steps: [
      "POST /api/v1/merchant/auth — username/password-оор нэвтэрч `token` авна.",
      "Авсан токэноо бүх хүсэлтийн `Authorization: Bearer <token>` header-т залгана.",
      "POST /api/v1/invoice — нэхэмжлэл үүсгэж, хариунд ирсэн `url` руу хэрэглэгчээ үсэргэнэ.",
      "POST /api/v1/invoice/:id/check эсвэл /bySecureId/:id/check — төлбөрийн төлөв болон НӨАТ-ын мэдээллийг шалгана.",
    ],
    notes: [
      "Токэн `1d` хугацаатай, refreshToken `7d` хугацаатай.",
      "Бүх дүн төгрөгөөр, JSON форматтай.",
      "`successCallback` URL рүү төлбөр амжилттай болсны дараа сервер дуудалт хийнэ.",
    ],
  },
  endPoints: [
    {
      group: "Authentication",
      title: "Мерчант нэвтрэх",
      method: "POST",
      path: "/api/v1/merchant/auth",
      auth: false,
      desc: "Мерчантын нэвтрэх нэр, нууц үг ашиглан JWT хандалтын токэн авна. Энэ токэныг дараагийн бүх хүсэлтийн `Authorization` header-т `Bearer <token>` хэлбэрээр оруулна.",
      bodyFields: [
        {
          name: "username",
          type: "string",
          required: true,
          desc: "Мерчантын нэвтрэх нэр",
        },
        {
          name: "password",
          type: "string",
          required: true,
          desc: "Нууц үг",
        },
      ],
      body: `{
  "username": "MERCHANT_1",
  "password": "MERCHANT_PASS"
}`,
      responses: [
        {
          status: 200,
          label: "Амжилттай",
          tone: "success",
          desc: "Токэн амжилттай үүссэн.",
          body: `{
  "success": true,
  "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "merchantId": 31,
  "expireIn": "1d",
  "refreshToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "refreshTokenExpireIn": "7d"
}`,
        },
        {
          status: 401,
          label: "Нэвтрэх нэр / нууц үг буруу",
          tone: "error",
          desc: "Илгээсэн мэдээлэл буруу үед буцаагдана.",
          body: `{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "message": "Нэвтрэх нэр, нууц үг буруу байна."
  }
}`,
        },
      ],
    },
    {
      group: "Invoice",
      title: "Нэхэмжлэл үүсгэх",
      method: "POST",
      path: "/api/v1/invoice",
      auth: true,
      desc: "Шинэ төлбөрийн нэхэмжлэл үүсгэнэ. `invoiceItems[].vatInfo` талбарыг хэрхэн илгээхээс шалтгаалж НӨАТ-ын баримтгүй эсвэл НӨАТ-ын баримттай нэхэмжлэл үүснэ. Хариуд ирсэн `url` нь хэрэглэгчийг төлбөрийн хуудас руу шилжүүлэх линк, харин `invoiceId`-г ашиглан төлбөрийн төлвийг шалгана.",
      callout: {
        tone: "info",
        title: "Webhook ба буцах хаяг (secureId)",
        body: "Төлбөр амжилттай болсны дараа Smartpay таны илгээсэн `returnUrl` болон `successCallback` хаягууд руу нэхэмжлэлийн `secureId`-г `?secureId=<uuid>` query параметрээр автоматаар нэмж дуудна. Та энэ `secureId`-г ашиглан `/api/v1/invoice/bySecureId/:id/check` endpoint-оор төлбөрийн төлөв болон НӨАТ-ын мэдээллийг хүлээн авна.",
        examples: [
          {
            label: "Та илгээсэн `returnUrl`",
            value: "https://your-site.mn/return",
          },
          {
            label: "Хэрэглэгч буцах үед",
            value:
              "https://your-site.mn/return?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12",
          },
          {
            label: "Та илгээсэн `successCallback`",
            value: "https://your-site.mn/api/payment/callback",
          },
          {
            label: "Smartpay-аас ирэх webhook",
            value:
              "https://your-site.mn/api/payment/callback?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12",
          },
        ],
      },
      variants: [
        {
          label: "НӨАТ-гүй",
          desc: "`vatInfo`-г `null` болгож илгээх үед НӨАТ-ын баримтгүй нэхэмжлэл үүснэ.",
          bodyFields: [
            { name: "amount", type: "number", required: true, desc: "Нийт төлөх дүн (₮)" },
            { name: "phone", type: "string", required: false, desc: "Хэрэглэгчийн утасны дугаар" },
            { name: "description", type: "string", required: false, desc: "Нэхэмжлэлийн тайлбар" },
            {
              name: "returnUrl",
              type: "string",
              required: true,
              desc: "Төлбөр төлсний дараа хэрэглэгчийг буцааж шилжүүлэх URL. Smartpay энэ хаягт нэхэмжлэлийн `secureId`-г `?secureId=<uuid>` query параметрээр автоматаар нэмж дуудна. Жишээ: `https://your-site.mn/return?secureId=2dc03c5b-...`",
            },
            {
              name: "successCallback",
              type: "string",
              required: true,
              desc: "Төлбөр амжилттай болсны дараа сервер рүү дуудах webhook URL. Энэ хаягт мөн `?secureId=<uuid>` query параметр нэмэгдэж дуудагдана. Хариуд `200` буцаавал амжилттайд тооцно.",
            },
            {
              name: "invoiceItems",
              type: "array<object>",
              required: true,
              desc: "Нэхэмжлэлийн зүйл бүрийн мэдээлэл. Дор хаяж 1 элемент байх ёстой.",
            },
            {
              name: "invoiceItems[].amount",
              type: "number",
              required: true,
              desc: "Зүйлийн дүн",
            },
            {
              name: "invoiceItems[].accountNumber",
              type: "string",
              required: true,
              desc: "Орлого хүлээж авах банкны дансны дугаар",
            },
            {
              name: "invoiceItems[].bankCode",
              type: "string",
              required: true,
              desc: "Банкны код (жишээ нь Хаан банк: 050000)",
            },
            {
              name: "invoiceItems[].productTypeId",
              type: "number",
              required: true,
              desc: "Бүтээгдэхүүний ангиллын ID",
            },
            {
              name: "invoiceItems[].vatInfo",
              type: "null",
              required: true,
              desc: "Энэ хүсэлтэд заавал `null` байна.",
            },
          ],
          body: `{
  "amount": 1000,
  "phone": "85858585",
  "description": "Тайлбар",
  "returnUrl": "https://your-site.mn/return",
  "successCallback": "https://your-site.mn/api/payment/callback",
  "invoiceItems": [
    {
      "amount": 1000,
      "accountNumber": "5302872893",
      "bankCode": "050000",
      "description": "Захиалга #105",
      "productTypeId": 1,
      "successCallback": "https://your-site.mn/api/payment/callback",
      "vatInfo": null
    }
  ]
}`,
          responses: [
            {
              status: 200,
              label: "Амжилттай",
              tone: "success",
              desc: "Нэхэмжлэл үүсэж, төлбөрийн линк буцаагдана.",
              body: `{
  "success": true,
  "invoiceId": 7,
  "url": "https://spay.esukh.mn/invoice?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12"
}`,
            },
          ],
        },
        {
          label: "НӨАТ-тай",
          desc: "`vatInfo` объектыг бөглөж илгээх үед НӨАТ-ын баримттай нэхэмжлэл үүсэх ба төлбөр амжилттай болсны дараа Татварын ерөнхий газарт цахим баримт автоматаар бүртгэгдэнэ.",
          bodyFields: [
            { name: "amount", type: "number", required: true, desc: "Нийт төлөх дүн (₮)" },
            { name: "phone", type: "string", required: false, desc: "Хэрэглэгчийн утасны дугаар" },
            { name: "description", type: "string", required: false, desc: "Нэхэмжлэлийн тайлбар" },
            {
              name: "returnUrl",
              type: "string",
              required: true,
              desc: "Төлбөр төлсний дараа хэрэглэгчийг буцааж шилжүүлэх URL. Smartpay энэ хаягт нэхэмжлэлийн `secureId`-г `?secureId=<uuid>` query параметрээр автоматаар нэмж дуудна. Жишээ: `https://your-site.mn/return?secureId=2dc03c5b-...`",
            },
            {
              name: "successCallback",
              type: "string",
              required: true,
              desc: "Төлбөр амжилттай болсны дараа сервер рүү дуудах webhook URL. Энэ хаягт мөн `?secureId=<uuid>` query параметр нэмэгдэж дуудагдана. Хариуд `200` буцаавал амжилттайд тооцно.",
            },
            {
              name: "invoiceItems",
              type: "array<object>",
              required: true,
              desc: "Нэхэмжлэлийн зүйл бүрийн мэдээлэл. Дор хаяж 1 элемент байх ёстой.",
            },
            {
              name: "invoiceItems[].amount",
              type: "number",
              required: true,
              desc: "Зүйлийн дүн",
            },
            {
              name: "invoiceItems[].accountNumber",
              type: "string",
              required: true,
              desc: "Орлого хүлээж авах банкны дансны дугаар",
            },
            {
              name: "invoiceItems[].bankCode",
              type: "string",
              required: true,
              desc: "Банкны код (жишээ нь Хаан банк: 050000)",
            },
            {
              name: "invoiceItems[].productTypeId",
              type: "number",
              required: true,
              desc: "Бүтээгдэхүүний ангиллын ID",
            },
            {
              name: "invoiceItems[].vatInfo",
              type: "object",
              required: true,
              desc: "НӨАТ-ын баримт үүсгэх мэдээлэл. Заавал бөглөнө.",
            },
            {
              name: "invoiceItems[].vatInfo.merchantRegister",
              type: "string",
              required: true,
              desc: "Худалдаа эрхлэгчийн регистрийн дугаар (TIN)",
            },
            {
              name: "invoiceItems[].vatInfo.type",
              type: "'B2C' | 'B2B'",
              required: true,
              desc: "Баримтын төрөл — `B2C` (хувь хүн), `B2B` (байгууллага)",
            },
            {
              name: "invoiceItems[].vatInfo.companyRegister",
              type: "string",
              required: false,
              desc: "B2B үед худалдан авагч байгууллагын регистрийн дугаар",
            },
          ],
          body: `{
  "amount": 1000,
  "phone": "85858585",
  "description": "Тайлбар",
  "returnUrl": "https://your-site.mn/return",
  "successCallback": "https://your-site.mn/api/payment/callback",
  "invoiceItems": [
    {
      "amount": 1000,
      "accountNumber": "5302872893",
      "bankCode": "050000",
      "description": "Захиалга #105",
      "productTypeId": 1,
      "successCallback": "https://your-site.mn/api/payment/callback",
      "vatInfo": {
        "merchantRegister": "8414661",
        "type": "B2C"
      }
    }
  ]
}`,
          responses: [
            {
              status: 200,
              label: "Амжилттай",
              tone: "success",
              desc: "Нэхэмжлэл үүсэж, төлбөрийн линк буцаагдана. Төлбөр амжилттай болсны дараа НӨАТ-ын баримт автоматаар бүртгэгдэх ба `/api/v1/invoice/:id/check` хүсэлтийн `invoiceItemVatInfo.qrJson` дотор QR кодыг авна.",
              body: `{
  "success": true,
  "invoiceId": 8,
  "url": "https://spay.esukh.mn/invoice?secureId=7f3a1b2c-9d4e-4a5b-8c7d-1e2f3a4b5c6d"
}`,
            },
          ],
        },
      ],
    },
    {
      group: "Invoice",
      title: "Нэхэмжлэлийн төлөв шалгах (ID-аар)",
      method: "POST",
      path: "/api/v1/invoice/:id/check",
      auth: true,
      desc: "Нэхэмжлэл үүсгэх үед буцаасан `invoiceId`-аар төлбөрийн төлөв, НӨАТ-ын QR, төлбөрийн арга зэрэг бүх дэлгэрэнгүй мэдээллийг авна.",
      pathParams: [
        {
          name: "id",
          type: "number",
          required: true,
          desc: "Нэхэмжлэл үүсгэх үед буцаасан `invoiceId`",
        },
      ],
      body: "",
      responses: [
        {
          status: 200,
          label: "Амжилттай",
          tone: "success",
          desc: "Нэхэмжлэлийн дэлгэрэнгүй мэдээлэл буцаагдана. `status` талбар нь `PAID`, `PENDING`, `CANCELED` зэрэг утгатай.",
          body: `{
  "success": true,
  "status": "PAID",
  "data": {
    "id": 135990,
    "amount": "3000.00",
    "createdAt": "2026-05-28T01:38:02.789Z",
    "status": "PAID",
    "returnUrl": "https://your-site.mn/return?data=...",
    "successCallback": "https://your-site.mn/api/payment/callback",
    "callBackResponse": "200",
    "invoiceItems": [
      {
        "id": 170045,
        "amount": "3000.00",
        "status": "PAID",
        "createdAt": "2026-05-28T01:38:02.819Z",
        "transaction": {
          "id": 213053,
          "status": "CREATED",
          "createdAt": "2026-05-28T01:38:11.825Z"
        },
        "invoiceItemVatInfo": {
          "id": 163571,
          "status": "DONE",
          "qrJson": {
            "id": "111975360867102096380004410013611",
            "totalAmount": 3000,
            "totalVAT": 0,
            "totalCityTax": 0,
            "merchantTin": "111975360867",
            "type": "B2C_RECEIPT",
            "lottery": "FT 49520263",
            "qrData": "354398584146108657...",
            "date": "2026-05-28 09:38:11"
          }
        }
      }
    ],
    "paymentMethod": { "name": "Пос" }
  }
}`,
        },
        {
          status: 401,
          label: "Токэн дутуу/буруу",
          tone: "error",
          desc: "Authorization header байхгүй эсвэл токэн хүчингүй.",
          body: `{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "statusCode": 401,
    "message": "Та нэвтэрч орно уу !"
  }
}`,
        },
      ],
    },
    {
      group: "Invoice",
      title: "Нэхэмжлэлийн төлөв шалгах (secureId-ээр)",
      method: "POST",
      path: "/api/v1/invoice/bySecureId/:id/check",
      auth: true,
      desc: "Нэхэмжлэлийн `url`-аас гарч ирсэн `secureId` (UUID) ашиглан төлбөрийн төлвийг шалгана. Хэрэглэгч талд харагдах төлбөрийн хуудаснаас буцаж ирэх үед ашиглахад тохиромжтой.",
      pathParams: [
        {
          name: "id",
          type: "string (UUID)",
          required: true,
          desc: "Нэхэмжлэл үүсгэх үеийн `url` дотор байсан `secureId`",
        },
      ],
      body: "",
      responses: [
        {
          status: 200,
          label: "Амжилттай",
          tone: "success",
          desc: "Нэхэмжлэлийн мэдээлэл болон НӨАТ-ын QR буцаагдана.",
          body: `{
    "id": 12,
    "amount": "100.00",
    "createdAt": "2025-02-21T06:29:39.060Z",
    "status": "PAID",
    "returnUrl": "http://localhost:3000/SpayReturn?data=141&option_id=3",
    "successCallback": "http://localhost:3000/payment/spayCheckSecure?inRecord=141&option_id=3",
    "callBackResponse": null,
    "invoiceItems": [
        {
            "id": 12,
            "amount": "100.00",
            "status": "PAID",
            "createdAt": "2025-02-21T06:29:39.258Z",
            "transaction": {
                "id": 11,
                "status": "CREATED",
                "createdAt": "2025-02-21T06:29:47.462Z"
            },
            "invoiceItemVatInfo": {
                "id": 10,
                "qrJson": {
                    "id": "083202407962102091770001210013611",
                    "version": "3.1.50",
                    "totalAmount": 100,
                    "totalVAT": 0,
                    "totalCityTax": 0,
                    "branchNo": "102",
                    "districtCode": "2509",
                    "merchantTin": "83202407962",
                    "posNo": "10013611",
                    "type": "B2C_RECEIPT",
                    "receipts": [
                        {
                            "id": "083202407962102091770001310013611",
                            "totalAmount": 100,
                            "taxType": "VAT_FREE",
                            "items": [
                                {
                                    "name": "Автомашины зогсоолын үйлчилгээ",
                                    "barCode": "",
                                    "barCodeType": "UNDEFINED",
                                    "classificationCode": "6743000",
                                    "taxProductCode": "403",
                                    "measureUnit": "",
                                    "qty": 1,
                                    "unitPrice": 100,
                                    "totalAmount": 100,
                                    "totalVAT": 0,
                                    "totalCityTax": 0,
                                    "data": {}
                                }
                            ],
                            "merchantTin": "83202407962",
                            "totalVAT": 0,
                            "totalCityTax": 0,
                            "data": {}
                        }
                    ],
                    "payments": [
                        {
                            "code": "BANK_TRANSFER",
                            "paidAmount": 100,
                            "status": "PAID",
                            "data": {}
                        }
                    ],
                    "data": {},
                    "posId": 7752412,
                    "status": "SUCCESS",
                    "qrData": "1384317094663456123621370753351736589644214920388021502791851559330833025480037248011495152781575492553173347498036161297774158586043391713124724368816167775",
                    "lottery": "GG 57236634",
                    "date": "2025-02-21 14:29:46",
                    "easy": false
                },
                "status": "DONE",
                "createdAt": "2025-02-21T06:29:39.159Z"
            }
        }
    ],
    "paymentMethod": {
        "name": "QPAY"
    }
}`,
        },
        {
          status: 400,
          label: "Нэхэмжлэл олдсонгүй",
          tone: "error",
          desc: "Илгээсэн `secureId`-тай нэхэмжлэл байхгүй.",
          body: `{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "statusCode": 400,
    "message": "invoice not found!"
  }
}`,
        },
      ],
    },
  ],
};

const METHOD_COLORS = {
  GET: "bg-blue-100 text-blue-700 border-blue-200",
  POST: "bg-emerald-100 text-emerald-700 border-emerald-200",
  PUT: "bg-amber-100 text-amber-700 border-amber-200",
  DELETE: "bg-rose-100 text-rose-700 border-rose-200",
  PATCH: "bg-violet-100 text-violet-700 border-violet-200",
};

const STATUS_TONES = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
  warn: "bg-amber-50 text-amber-700 border-amber-200",
};

const MethodBadge = ({ method }) => (
  <span
    className={`inline-flex items-center justify-center px-2.5 py-1 text-xs font-bold rounded-md border min-w-[60px] ${
      METHOD_COLORS[method] || "bg-gray-100 text-gray-700 border-gray-200"
    }`}
  >
    {method}
  </span>
);

const CopyButton = ({ text, label = "Хуулах" }) => {
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      message.success("Хуулагдлаа");
    } catch {
      message.error("Хуулж чадсангүй");
    }
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      className="text-xs text-gray-500 hover:text-gray-800 border border-gray-200 rounded px-2 py-1 hover:bg-gray-50 transition-colors"
    >
      {label}
    </button>
  );
};

const CodeBlock = ({ code, language = "json" }) => (
  <div className="relative">
    <div className="absolute right-2 top-2">
      <CopyButton text={code} />
    </div>
    <pre className="bg-[#0f172a] text-[#e2e8f0] text-[12.5px] leading-relaxed p-4 pr-20 rounded-lg overflow-auto max-h-[420px] whitespace-pre">
      <code className={`language-${language}`}>{code}</code>
    </pre>
  </div>
);

const FieldsTable = ({ title, fields }) => {
  if (!fields || fields.length === 0) return null;
  return (
    <div className="mt-4">
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
        {title}
      </div>
      <div className="overflow-hidden border border-gray-200 rounded-lg">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr className="text-left text-xs font-semibold text-gray-500">
              <th className="px-3 py-2 w-1/4">Талбар</th>
              <th className="px-3 py-2 w-1/6">Төрөл</th>
              <th className="px-3 py-2 w-[90px]">Заавал</th>
              <th className="px-3 py-2">Тайлбар</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {fields.map((f) => (
              <tr key={f.name} className="hover:bg-gray-50/60">
                <td className="px-3 py-2 font-mono text-[12.5px] text-gray-800 align-top">
                  {f.name}
                </td>
                <td className="px-3 py-2 font-mono text-[12px] text-violet-700 align-top">
                  {f.type}
                </td>
                <td className="px-3 py-2 align-top">
                  {f.required ? (
                    <span className="text-[11px] font-semibold text-rose-600 bg-rose-50 border border-rose-200 px-2 py-0.5 rounded">
                      Заавал
                    </span>
                  ) : (
                    <span className="text-[11px] text-gray-400">—</span>
                  )}
                </td>
                <td className="px-3 py-2 text-gray-700 align-top">{f.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ResponseTabs = ({ responses }) => {
  const [active, setActive] = useState(0);
  if (!responses || responses.length === 0) return null;
  const current = responses[active];
  return (
    <div className="mt-4">
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
        Хариу (Response)
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        {responses.map((r, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setActive(idx)}
            className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${
              active === idx
                ? STATUS_TONES[r.tone] || "bg-gray-100 text-gray-700 border-gray-200"
                : "bg-white text-gray-500 border-gray-200 hover:bg-gray-50"
            }`}
          >
            <span className="font-bold mr-1">{r.status}</span>
            {r.label}
          </button>
        ))}
      </div>
      {current.desc && (
        <p className="text-xs text-gray-600 mb-2">{current.desc}</p>
      )}
      <CodeBlock code={current.body} />
    </div>
  );
};

const CALLOUT_TONES = {
  info: {
    box: "bg-sky-50 border-sky-200",
    title: "text-sky-800",
    body: "text-sky-900/80",
    icon: "💡",
  },
  warn: {
    box: "bg-amber-50 border-amber-200",
    title: "text-amber-800",
    body: "text-amber-900/80",
    icon: "⚠️",
  },
  success: {
    box: "bg-emerald-50 border-emerald-200",
    title: "text-emerald-800",
    body: "text-emerald-900/80",
    icon: "✅",
  },
};

const Callout = ({ callout }) => {
  if (!callout) return null;
  const tone = CALLOUT_TONES[callout.tone] || CALLOUT_TONES.info;
  return (
    <div className={`mt-4 border rounded-lg p-4 ${tone.box}`}>
      {callout.title && (
        <div className={`text-sm font-semibold mb-1 flex items-center gap-2 ${tone.title}`}>
          <span>{tone.icon}</span>
          <span>{callout.title}</span>
        </div>
      )}
      {callout.body && (
        <p className={`text-[13px] leading-relaxed ${tone.body}`}>
          {callout.body}
        </p>
      )}
      {Array.isArray(callout.examples) && callout.examples.length > 0 && (
        <div className="mt-3 space-y-1.5">
          {callout.examples.map((ex, i) => (
            <div
              key={i}
              className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3 text-[12.5px]"
            >
              <span className={`shrink-0 font-medium ${tone.title}`}>
                {ex.label}:
              </span>
              <code className="font-mono bg-white/70 border border-gray-200 rounded px-2 py-0.5 text-gray-800 break-all">
                {ex.value}
              </code>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const VariantBody = ({ variant }) => {
  const hasBody = variant.body && variant.body.trim().length > 0;
  return (
    <>
      {variant.desc && (
        <p className="text-sm text-gray-700 leading-relaxed bg-[#2EA5A1]/5 border-l-2 border-[#2EA5A1] pl-3 py-2 rounded-r mt-4">
          {variant.desc}
        </p>
      )}
      <FieldsTable title="Body талбарууд" fields={variant.bodyFields} />
      {hasBody && (
        <div className="mt-4">
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
            Хүсэлтийн body (JSON)
          </div>
          <CodeBlock code={variant.body} />
        </div>
      )}
      <ResponseTabs responses={variant.responses} />
    </>
  );
};

const VariantTabs = ({ variants }) => {
  const [active, setActive] = useState(0);
  if (!variants || variants.length === 0) return null;
  const current = variants[active];
  return (
    <div className="mt-4">
      <div className="flex flex-wrap gap-2 border-b border-gray-200 mb-1">
        {variants.map((v, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setActive(idx)}
            className={`text-sm px-4 py-2 -mb-px border-b-2 font-medium transition-colors ${
              active === idx
                ? "border-[#2EA5A1] text-[#2EA5A1]"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>
      <VariantBody variant={current} />
    </div>
  );
};

const EndpointCard = ({ ep, baseUrl, id }) => {
  const fullUrl = baseUrl + ep.path;
  const hasBody = ep.body && ep.body.trim().length > 0;
  const hasVariants = Array.isArray(ep.variants) && ep.variants.length > 0;
  return (
    <div
      id={id}
      className="bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow p-5 scroll-mt-6"
    >
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-3">
        <div className="flex items-start gap-3 min-w-0">
          <MethodBadge method={ep.method} />
          <div className="min-w-0">
            <div className="font-semibold text-gray-900">{ep.title}</div>
            <div className="text-[12.5px] text-gray-500 font-mono break-all mt-0.5">
              {fullUrl}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {ep.auth ? (
            <span className="text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-2 py-1 rounded">
              🔒 Bearer token шаардлагатай
            </span>
          ) : (
            <span className="text-[11px] font-semibold text-gray-500 bg-gray-50 border border-gray-200 px-2 py-1 rounded">
              Нээлттэй
            </span>
          )}
          <CopyButton text={fullUrl} label="URL" />
        </div>
      </div>

      {ep.desc && (
        <p className="text-sm text-gray-700 leading-relaxed border-l-2 border-[#2EA5A1] pl-3">
          {ep.desc}
        </p>
      )}

      <Callout callout={ep.callout} />

      <FieldsTable title="Path параметр" fields={ep.pathParams} />

      {hasVariants ? (
        <VariantTabs variants={ep.variants} />
      ) : (
        <>
          <FieldsTable title="Body талбарууд" fields={ep.bodyFields} />
          {hasBody && (
            <div className="mt-4">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Хүсэлтийн body (JSON)
              </div>
              <CodeBlock code={ep.body} />
            </div>
          )}
          <ResponseTabs responses={ep.responses} />
        </>
      )}
    </div>
  );
};

const LegacyEndpointCard = ({ ep, baseUrl, id }) => (
  <div
    id={id}
    className="bg-white border border-gray-100 rounded-xl shadow-md p-5 scroll-mt-6"
  >
    <div className="flex justify-between items-center mb-2">
      <div className="flex items-center gap-3">
        <MethodBadge method={ep.method} />
        <span className="font-semibold text-gray-800">{ep.title}</span>
      </div>
      <span className="text-xs text-[#66baa8] font-mono break-all">
        {baseUrl + ep.path}
      </span>
    </div>
    <p className="text-sm text-gray-600">{ep.desc}</p>
    <div className="mt-3">
      <label className="text-xs font-semibold text-gray-500 mb-1 block">
        JSON Body:
      </label>
      <pre className="bg-gray-50 text-sm text-gray-800 p-3 rounded border border-gray-200 overflow-auto whitespace-pre-wrap">
        {ep.body}
      </pre>
    </div>
  </div>
);

const getEndpointId = (idx) => `ep-${idx}`;

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Sidebar = ({ endPoints, hasIntro, activeId, onSelect }) => {
  const groups = useMemo(() => {
    const map = new Map();
    (endPoints || []).forEach((ep, idx) => {
      const key = ep.group || "Endpoints";
      if (!map.has(key)) map.set(key, []);
      map.get(key).push({ ep, idx });
    });
    return Array.from(map.entries());
  }, [endPoints]);

  return (
    <aside className="hidden lg:block w-64 shrink-0">
      <nav className="sticky top-6 max-h-[calc(100vh-3rem)] overflow-y-auto bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
        <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3 px-2">
          Контент
        </div>
        {hasIntro && (
          <button
            type="button"
            onClick={() => onSelect("intro")}
            className={`w-full text-left text-sm px-2 py-1.5 rounded transition-colors ${
              activeId === "intro"
                ? "bg-[#2EA5A1]/10 text-[#2EA5A1] font-medium"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            📖 Эхлэхэд
          </button>
        )}
        {hasIntro && (
          <button
            type="button"
            onClick={() => onSelect("agent-prompt")}
            className={`w-full text-left text-sm px-2 py-1.5 rounded transition-colors mb-3 ${
              activeId === "agent-prompt"
                ? "bg-violet-100 text-violet-700 font-medium"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            🤖 AI Agent Prompt
          </button>
        )}
        {groups.map(([groupName, items]) => (
          <div key={groupName} className="mb-3">
            <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider px-2 mb-1">
              {groupName}
            </div>
            <ul className="space-y-0.5">
              {items.map(({ ep, idx }) => {
                const id = getEndpointId(idx);
                const isActive = activeId === id;
                return (
                  <li key={id}>
                    <button
                      type="button"
                      onClick={() => onSelect(id)}
                      className={`w-full flex items-start gap-2 text-left px-2 py-1.5 rounded text-[13px] transition-colors ${
                        isActive
                          ? "bg-[#2EA5A1]/10 text-[#2EA5A1] font-medium"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <span
                        className={`text-[10px] font-bold mt-0.5 shrink-0 ${
                          ep.method === "POST"
                            ? "text-emerald-600"
                            : ep.method === "GET"
                            ? "text-blue-600"
                            : "text-gray-500"
                        }`}
                      >
                        {ep.method}
                      </span>
                      <span className="leading-snug">{ep.title}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
};

const IntroSection = ({ intro }) => {
  if (!intro) return null;
  return (
    <div
      id="intro"
      className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6 mb-6 scroll-mt-6"
    >
      <div className="text-base font-semibold text-gray-900 mb-2">
        Эхлэхэд
      </div>
      <p className="text-sm text-gray-700 leading-relaxed mb-4">
        {intro.summary}
      </p>
      {intro.steps && (
        <div className="mb-4">
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
            Урсгал
          </div>
          <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700">
            {intro.steps.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ol>
        </div>
      )}
      {intro.notes && (
        <div>
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
            Анхаарах
          </div>
          <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
            {intro.notes.map((n, i) => (
              <li key={i}>{n}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const buildAgentPrompt = ({ baseUrl, username, password }) => `# Smartpay Payment API — AI Agent Integration Guide

Та энэ prompt-ыг уншсаны дараа Smartpay системтэй бүрэн ажиллах чадвартай болно:
нэвтрэх, нэхэмжлэл үүсгэх, webhook хүлээн авах, төлбөрийн төлөв шалгах.

---

## Үндсэн тохиргоо

| Талбар | Утга |
|---|---|
| Base URL | ${baseUrl} |
| Authentication | Bearer JWT Token |
| Content-Type | application/json |
| Мөнгөн дүн | Монгол төгрөг (MNT), бүхэл тоо |

---

## ENDPOINT 1 — Нэвтрэх (токэн авах)

### Хүсэлт
\`\`\`
POST ${baseUrl}/api/v1/merchant/auth
Content-Type: application/json
\`\`\`
\`\`\`json
{
  "username": "${username || "YOUR_USERNAME"}",
  "password": "${password || "YOUR_PASSWORD"}"
}
\`\`\`

### Хариу — 200 Амжилттай
\`\`\`json
{
  "success": true,
  "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzEsImlhdCI6MTc3OTkzMjI0OCwiZXhwIjoxNzgwMDE4NjQ4fQ.esmrFmutQ_IPEcWe8yji6Hr_4g0QM6fmht7FDtuZMpg",
  "merchantId": 31,
  "expireIn": "1d",
  "refreshToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzEsImlhdCI6MTc3OTkzMjI0OCwiZXhwIjoxNzgwNTM3MDQ4fQ.hgoEgEa9F5W_5X-prQ6Jcm6QitZXwoujmBHrQpCTpl0",
  "refreshTokenExpireIn": "7d"
}
\`\`\`

| Талбар | Тайлбар |
|---|---|
| success | true бол амжилттай |
| token | JWT хандалтын токэн. 1 хоногт дуусна. Бүх хүсэлтэд \`Authorization: Bearer [token]\` header болгон залгана |
| merchantId | Мерчантын ID |
| expireIn | Токэний хугацаа |
| refreshToken | 7 хоногт дуусна. Токэн дуусвал дахин нэвтрэхгүйгээр шинэ токэн авахад ашиглана |
| refreshTokenExpireIn | Refresh токэний хугацаа |

### Хариу — 401 Буруу нэвтрэх нэр/нууц үг
\`\`\`json
{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "message": "Нэвтрэх нэр, нууц үг буруу байна."
  }
}
\`\`\`

⚠️ **Чухал:** Авсан \`token\`-г дараагийн бүх хүсэлтийн header-т заавал оруулна:
\`Authorization: Bearer eyJhbGciOiJIUzI1NiIs...\`

---

## ENDPOINT 2 — Нэхэмжлэл үүсгэх

### Хүсэлт
\`\`\`
POST ${baseUrl}/api/v1/invoice
Authorization: Bearer [TOKEN]
Content-Type: application/json
\`\`\`

### Хүсэлтийн талбарууд

| Талбар | Төрөл | Заавал | Тайлбар |
|---|---|---|---|
| amount | number | ✅ | Нийт төлбөрийн дүн (₮) |
| phone | string | — | Хэрэглэгчийн утасны дугаар |
| description | string | — | Нэхэмжлэлийн тайлбар |
| returnUrl | string | ✅ | Төлбөр дууссаны дараа хэрэглэгч буцах URL. Smartpay энэ URL-д \`?secureId=[UUID]\` нэмж redirect хийнэ |
| successCallback | string | ✅ | Төлбөр амжилттай болсны дараа таны серверт POST дуудалт хийх webhook URL. URL-д \`?secureId=[UUID]\` нэмэгдэнэ. Та 200 буцааж баталгаажуулна |
| invoiceItems | array | ✅ | Нэхэмжлэлийн зүйлүүд. Дор хаяж 1 байна |
| invoiceItems[].amount | number | ✅ | Зүйлийн дүн |
| invoiceItems[].accountNumber | string | ✅ | Орлого хүлээн авах дансны дугаар |
| invoiceItems[].bankCode | string | ✅ | Банкны код (Хаан: 050000, Голомт: 150000, Хас: 040000, Тэнгэр: 010000, Хадгаламж: 320000) |
| invoiceItems[].productTypeId | number | ✅ | Бүтээгдэхүүний ангиллын ID |
| invoiceItems[].successCallback | string | ✅ | Item түвшний webhook URL |
| invoiceItems[].vatInfo | object or null | ✅ | НӨАТ-ын мэдээлэл. НӨАТ-гүй бол null |
| invoiceItems[].vatInfo.merchantRegister | string | ✅* | Худалдаа эрхлэгчийн регистрийн дугаар (TIN). vatInfo байх үед заавал |
| invoiceItems[].vatInfo.type | string | ✅* | Баримтын төрөл: "B2C" (хувь хүнд) эсвэл "B2B" (байгууллагад) |
| invoiceItems[].vatInfo.companyRegister | string | — | B2B үед худалдан авагч байгууллагын регистр |

### Жишээ 1 — НӨАТ-гүй (vatInfo: null)
\`\`\`json
{
  "amount": 1000,
  "phone": "85858585",
  "description": "Захиалга #105",
  "returnUrl": "https://your-site.mn/return",
  "successCallback": "https://your-site.mn/api/payment/callback",
  "invoiceItems": [
    {
      "amount": 1000,
      "accountNumber": "5302872893",
      "bankCode": "050000",
      "description": "Захиалга #105",
      "productTypeId": 1,
      "successCallback": "https://your-site.mn/api/payment/callback",
      "vatInfo": null
    }
  ]
}
\`\`\`

### Жишээ 2 — НӨАТ-тай (vatInfo бөглөсөн)
\`\`\`json
{
  "amount": 1000,
  "phone": "85858585",
  "description": "Захиалга #105",
  "returnUrl": "https://your-site.mn/return",
  "successCallback": "https://your-site.mn/api/payment/callback",
  "invoiceItems": [
    {
      "amount": 1000,
      "accountNumber": "5302872893",
      "bankCode": "050000",
      "description": "Захиалга #105",
      "productTypeId": 1,
      "successCallback": "https://your-site.mn/api/payment/callback",
      "vatInfo": {
        "merchantRegister": "8414661",
        "type": "B2C"
      }
    }
  ]
}
\`\`\`

### Хариу — 200 Амжилттай
\`\`\`json
{
  "success": true,
  "invoiceId": 7,
  "url": "https://spay.esukh.mn/invoice?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12"
}
\`\`\`

| Талбар | Тайлбар |
|---|---|
| success | true бол нэхэмжлэл амжилттай үүссэн |
| invoiceId | Нэхэмжлэлийн дотоод ID. Төлөв шалгахад ашиглана |
| url | Хэрэглэгчийг энэ URL руу redirect хийнэ. URL дотор secureId байгаа (\`?secureId=2dc03c5b-...\`). Энэ secureId-г хадгалж авна |

➡️ **Хийх зүйл:** \`url\`-г хэрэглэгчийн браузерт redirect хийнэ. \`secureId\`-г URL-аас задлаж хадгална.

---

## WEBHOOK болон БУЦАХ ХАЯГ — secureId дамжуулалт

Хэрэглэгч төлбөр төлсний дараа Smartpay таны 2 хаяг руу \`secureId\` нэмж дуудна:

| | Таны илгээсэн хаяг | Smartpay-аас ирэх |
|---|---|---|
| returnUrl (browser) | https://your-site.mn/return | https://your-site.mn/return?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12 |
| successCallback (server) | https://your-site.mn/api/payment/callback | https://your-site.mn/api/payment/callback?secureId=2dc03c5b-5854-40bf-9601-82a66e5ebb12 |

- **returnUrl** — хэрэглэгч браузерт буцаж ирэх URL. Та \`req.query.secureId\`-г авч төлөв шалгана
- **successCallback** — таны backend-д ирэх webhook. Та \`req.query.secureId\`-г авч төлөвийг шалгаж, амжилттай бол дотоод логикоо гүйцэтгэнэ. Заавал **HTTP 200** буцаана

---

## ENDPOINT 3 — Нэхэмжлэлийн төлөв шалгах (secureId-ээр)

Хамгийн түгээмэл — returnUrl болон successCallback-оос secureId авсны дараа дуудна.

### Хүсэлт
\`\`\`
POST ${baseUrl}/api/v1/invoice/bySecureId/[SECURE_ID]/check
Authorization: Bearer [TOKEN]
\`\`\`

### Хариу — 200 Амжилттай (PAID жишээ)
\`\`\`json
{
  "id": 12,
  "amount": "100.00",
  "createdAt": "2025-02-21T06:29:39.060Z",
  "status": "PAID",
  "returnUrl": "https://your-site.mn/return?data=141&option_id=3",
  "successCallback": "https://your-site.mn/api/payment/callback",
  "callBackResponse": null,
  "invoiceItems": [
    {
      "id": 12,
      "amount": "100.00",
      "status": "PAID",
      "createdAt": "2025-02-21T06:29:39.258Z",
      "transaction": {
        "id": 11,
        "status": "CREATED",
        "createdAt": "2025-02-21T06:29:47.462Z"
      },
      "invoiceItemVatInfo": {
        "id": 10,
        "status": "DONE",
        "createdAt": "2025-02-21T06:29:39.159Z",
        "qrJson": {
          "id": "083202407962102091770001210013611",
          "version": "3.1.50",
          "totalAmount": 100,
          "totalVAT": 0,
          "totalCityTax": 0,
          "branchNo": "102",
          "districtCode": "2509",
          "merchantTin": "83202407962",
          "posNo": "10013611",
          "type": "B2C_RECEIPT",
          "receipts": [
            {
              "id": "083202407962102091770001310013611",
              "totalAmount": 100,
              "taxType": "VAT_FREE",
              "merchantTin": "83202407962",
              "totalVAT": 0,
              "totalCityTax": 0,
              "items": [
                {
                  "name": "Автомашины зогсоолын үйлчилгээ",
                  "classificationCode": "6743000",
                  "taxProductCode": "403",
                  "qty": 1,
                  "unitPrice": 100,
                  "totalAmount": 100,
                  "totalVAT": 0,
                  "totalCityTax": 0
                }
              ]
            }
          ],
          "payments": [
            {
              "code": "BANK_TRANSFER",
              "paidAmount": 100,
              "status": "PAID"
            }
          ],
          "posId": 7752412,
          "status": "SUCCESS",
          "qrData": "1384317094663456123621370753351736589644214920388...",
          "lottery": "GG 57236634",
          "date": "2025-02-21 14:29:46",
          "easy": false
        }
      }
    }
  ],
  "paymentMethod": {
    "name": "QPAY"
  }
}
\`\`\`

| Талбар | Тайлбар |
|---|---|
| status | Нэхэмжлэлийн төлөв: \`PAID\` / \`PENDING\` / \`CANCELED\` |
| callBackResponse | Таны successCallback-аас буцаасан HTTP статус код. null бол дуудалт болоогүй |
| invoiceItems[].status | Item-ийн төлөв |
| invoiceItems[].transaction | Банкны гүйлгээний мэдээлэл |
| invoiceItems[].invoiceItemVatInfo | НӨАТ-ын баримтын мэдээлэл. vatInfo: null бол энэ талбар байхгүй байж болно |
| invoiceItemVatInfo.status | \`DONE\` — НӨАТ бүртгэгдсэн, \`PENDING\` — хүлээгдэж байна |
| invoiceItemVatInfo.qrJson.lottery | НӨАТ-ын сугалааны дугаар |
| invoiceItemVatInfo.qrJson.qrData | НӨАТ QR кодын мэдээлэл |
| invoiceItemVatInfo.qrJson.type | Баримтын төрөл: \`B2C_RECEIPT\` эсвэл \`B2B_RECEIPT\` |
| paymentMethod.name | Ашигласан төлбөрийн хэрэгсэл: \`QPAY\`, \`Пос\` гэх мэт |

### Хариу — 400 Нэхэмжлэл олдсонгүй
\`\`\`json
{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "statusCode": 400,
    "message": "invoice not found!"
  }
}
\`\`\`

---

## ENDPOINT 4 — Нэхэмжлэлийн төлөв шалгах (invoiceId-ээр)

Нэхэмжлэл үүсгэх үед авсан \`invoiceId\`-аар шалгана.

### Хүсэлт
\`\`\`
POST ${baseUrl}/api/v1/invoice/[INVOICE_ID]/check
Authorization: Bearer [TOKEN]
\`\`\`
Body хоосон байж болно.

### Хариу — 200 Амжилттай (PAID жишээ)
\`\`\`json
{
  "success": true,
  "status": "PAID",
  "data": {
    "id": 135990,
    "amount": "3000.00",
    "createdAt": "2026-05-28T01:38:02.789Z",
    "status": "PAID",
    "returnUrl": "https://your-site.mn/return",
    "successCallback": "https://your-site.mn/api/payment/callback",
    "callBackResponse": "200",
    "qpayHistories": [],
    "negdiHistories": [],
    "invoiceItems": [
      {
        "id": 170045,
        "amount": "3000.00",
        "status": "PAID",
        "createdAt": "2026-05-28T01:38:02.819Z",
        "transaction": {
          "id": 213053,
          "status": "CREATED",
          "createdAt": "2026-05-28T01:38:11.825Z"
        },
        "invoiceItemVatInfo": {
          "id": 163571,
          "status": "DONE",
          "createdAt": "2026-05-28T01:38:02.804Z",
          "qrJson": {
            "id": "111975360867102096380004410013611",
            "version": "3.2.44",
            "totalAmount": 3000,
            "totalVAT": 0,
            "totalCityTax": 0,
            "branchNo": "102",
            "districtCode": "2316",
            "merchantTin": "111975360867",
            "posNo": "10013611",
            "type": "B2C_RECEIPT",
            "receipts": [
              {
                "id": "111975360867102096380004510013611",
                "totalAmount": 3000,
                "taxType": "VAT_ABLE",
                "merchantTin": "111975360867",
                "totalVAT": 0,
                "totalCityTax": 0,
                "items": [
                  {
                    "name": "Автомашины зогсоолын үйлчилгээ",
                    "classificationCode": "6743000",
                    "qty": 1,
                    "unitPrice": 3000,
                    "totalAmount": 3000,
                    "totalVAT": 0,
                    "totalCityTax": 0
                  }
                ]
              }
            ],
            "payments": [
              {
                "code": "BANK_TRANSFER",
                "paidAmount": 3000,
                "status": "PAID"
              }
            ],
            "posId": 7752412,
            "status": "SUCCESS",
            "qrData": "354398584146108657623162655898982506607479073877...",
            "lottery": "FT 49520263",
            "date": "2026-05-28 09:38:11",
            "easy": false
          }
        }
      }
    ],
    "paymentMethod": {
      "name": "Пос"
    }
  }
}
\`\`\`

| Талбар | Тайлбар |
|---|---|
| success | true бол хүсэлт амжилттай |
| status | Нэхэмжлэлийн дээд түвшний төлөв |
| data.callBackResponse | Таны webhook-аас ирсэн HTTP статус. "200" бол webhook амжилттай ажилласан |
| data.qpayHistories | QPay-ийн төлбөрийн түүх |
| data.negdiHistories | Нэгдэл системийн төлбөрийн түүх |
| invoiceItemVatInfo.qrJson.taxType | \`VAT_ABLE\` (НӨАТ ногдох) / \`VAT_FREE\` (НӨАТ чөлөөлөгдсөн) |
| invoiceItemVatInfo.qrJson.payments[].code | Төлбөрийн хэрэгсэл: \`BANK_TRANSFER\`, \`QPAY\` гэх мэт |
| invoiceItemVatInfo.qrJson.lottery | НӨАТ-ын сугалааны дугаар — хэрэглэгчид харуулах |

### Хариу — 401 Токэн хүчингүй
\`\`\`json
{
  "success": false,
  "error": {
    "messageEng": "an accidental error occurred",
    "statusCode": 401,
    "message": "Та нэвтэрч орно уу !"
  }
}
\`\`\`

---

## Алдааны хариуны бүтэц

Бүх алдаа дараах нийтлэг бүтцээр ирнэ:
\`\`\`json
{
  "success": false,
  "error": {
    "statusCode": 400,
    "message": "Монгол тайлбар",
    "messageEng": "English description"
  }
}
\`\`\`

| HTTP код | Учир | Шийдэл |
|---|---|---|
| 401 | Токэн байхгүй, хугацаа дууссан, буруу | ENDPOINT 1-ээр дахин нэвтэрч шинэ токэн авна |
| 400 | Body дутуу, буруу утга, нэхэмжлэл олдсонгүй | Хүсэлтийн мэдээллийг шалгана |
| 500 | Серверийн алдаа | Дахин оролдох, шаардлагатай бол холбоо барина |

---

## Бүрэн интеграцийн урсгал

\`\`\`
[1] POST /api/v1/merchant/auth
    → token, refreshToken хадгална

[2] POST /api/v1/invoice (Authorization: Bearer [TOKEN])
    → invoiceId, url (url-д secureId байна) хадгална
    → хэрэглэгчийг url руу redirect хийнэ

[3] Хэрэглэгч Smartpay хуудсан дээр төлбөр төлнэ

[4a] returnUrl?secureId=[UUID] (browser redirect)
     → frontend: secureId авч /check дуудна

[4b] successCallback?secureId=[UUID] (server POST)
     → backend: secureId авч /check дуудна
     → амжилттай бол дотоод логик гүйцэтгэнэ
     → заавал HTTP 200 буцаана

[5] POST /api/v1/invoice/bySecureId/[SECURE_ID]/check
    → status === "PAID" бол баталгаажсан
    → invoiceItemVatInfo.qrJson.lottery → сугалааны дугаар
\`\`\`

---

## Практик дүрэм

- Токэн дуусвал \`success: false, statusCode: 401\` ирнэ — дахин нэвтэрч шинэ токэн аваад хүсэлтийг давтана
- \`successCallback\`-аас заавал \`200\` буцааж байгаа эсэхийг шалга — буцаагаагүй бол Smartpay дахин дуудаж болно
- НӨАТ-тай нэхэмжлэлд \`invoiceItemVatInfo.status === "DONE"\` болох хүртэл хэдэн секунд хүлээх шаардлагатай байж болно
- \`qpayHistories\` болон \`negdiHistories\` массивуудын агуулга нь дараа нэмэгдэж болно
`;

const AgentPromptSection = ({ baseUrl }) => {
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [copied, setCopied] = useState(false);

  const prompt = useMemo(
    () => buildAgentPrompt({ baseUrl, username, password }),
    [baseUrl, username, password]
  );

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      message.error("Хуулж чадсангүй");
    }
  };

  const onDownload = () => {
    const blob = new Blob([prompt], { type: "text/markdown;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "smartpay_agent_prompt.md";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      id="agent-prompt"
      className="bg-white border border-violet-200 rounded-2xl shadow-sm overflow-hidden mb-6 scroll-mt-6"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-6 py-4 hover:bg-violet-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-xl">🤖</span>
          <div className="text-left">
            <div className="font-semibold text-gray-900">
              AI Agent Prompt татах
            </div>
            <div className="text-xs text-gray-500 mt-0.5">
              Таны AI agent Smartpay-тай холбогдоход ашиглах бэлэн prompt
            </div>
          </div>
        </div>
        <svg
          className={`h-5 w-5 text-gray-400 transition-transform ${
            open ? "rotate-180" : ""
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <div className="border-t border-violet-100 px-6 py-5">
          <p className="text-sm text-gray-700 mb-4">
            Энэ prompt-ыг таны AI agent-д өгснөөр тухайн agent Smartpay API-тай
            нэвтрэлт, нэхэмжлэл үүсгэх, төлбөрийн төлөв шалгах зэрэг үйлдлийг
            гүйцэтгэх чадвартай болно.
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 text-[13px] text-amber-800">
            ⚠️ Prompt дотор нэвтрэх нэр, нууц үгийг оруулах бол дороос
            нөхнө. Хоосон орхивол <strong>YOUR_USERNAME</strong>,{" "}
            <strong>YOUR_PASSWORD</strong> гэж байх бөгөөд agent өөрөө тохируулна.
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4">
            <div>
              <label className="text-xs font-semibold text-gray-500 mb-1 block">
                Нэвтрэх нэр (заавал биш)
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="YOUR_USERNAME"
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-500 mb-1 block">
                Нууц үг (заавал биш)
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="YOUR_PASSWORD"
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
              />
            </div>
          </div>

          <div className="flex gap-2 mb-4">
            <button
              type="button"
              onClick={onCopy}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                copied
                  ? "bg-emerald-500 text-white"
                  : "bg-violet-600 hover:bg-violet-700 text-white"
              }`}
            >
              {copied ? (
                <>✅ Хуулагдлаа</>
              ) : (
                <>
                  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  Prompt хуулах
                </>
              )}
            </button>
            <button
              type="button"
              onClick={onDownload}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors"
            >
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              .md татах
            </button>
          </div>

          <div className="relative rounded-lg overflow-hidden border border-gray-200">
            <div className="absolute right-3 top-3 z-10">
              <CopyButton text={prompt} label="Хуулах" />
            </div>
            <pre className="bg-[#0f172a] text-[#e2e8f0] text-[11.5px] leading-relaxed p-4 pr-20 overflow-auto max-h-[400px] whitespace-pre">
              {prompt}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

const BillingDoc = () => {
  const [data, setData] = useState(null);
  const { permissions } = useMerchant();
  const xpayUser = permissions?.find((e) => e === 2) || false;
  const [activeUrl, setActiveUrl] = useState("prod");
  const [activeId, setActiveId] = useState("intro");

  useEffect(() => {
    if (xpayUser) setData(xPayEndpoints);
    else setData(billingEndpoints);
  }, [xpayUser]);

  useEffect(() => {
    if (!data) return;
    const ids = [
      ...(xpayUser && data.intro ? ["intro", "agent-prompt"] : []),
      ...data.endPoints.map((_, idx) => getEndpointId(idx)),
    ];
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.target.offsetTop - b.target.offsetTop);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: "-20% 0px -70% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [data, xpayUser]);

  const handleSidebarSelect = (id) => {
    setActiveId(id);
    scrollToId(id);
  };

  const downloadPostmanDoc = (url) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  const envOptions = useMemo(
    () =>
      Object.keys(data?.baseUrl || ENVIRONMENTS).map((key) => ({
        label: key === "test" ? "🧪 Туршилт" : "🚀 Бодит орчин",
        value: key,
      })),
    [data]
  );

  const currentBase =
    data?.baseUrl?.[activeUrl] || ENVIRONMENTS[activeUrl] || "";

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <div
        className={`${bg_button} p-6 rounded-2xl mb-8 shadow-sm border border-green-200`}
      >
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-100">
              {xpayUser ? "Smartpay API гарын авлага" : "Смартбиллинг API гарын авлага"}
            </h1>
            <p className="text-gray-100/90 mt-1 text-sm">
              {data?.title || "API гарын авлага ачааллаж байна..."}
            </p>
            <p className="text-gray-100/80 mt-2 text-xs font-mono break-all">
              Base URL: {currentBase}
            </p>
          </div>

          <div className="flex items-end gap-3 flex-col">
            <Select
              value={activeUrl}
              className="w-52"
              size="small"
              onChange={(e) => setActiveUrl(e)}
              options={envOptions}
            />
            <div
              onClick={() => downloadPostmanDoc(data?.docUrl)}
              className="inline-flex items-center gap-2 cursor-pointer bg-[#FF6C37] hover:bg-[#e75b2b] text-white font-semibold text-sm px-4 py-2 rounded-md shadow transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4"
                />
              </svg>
              Postman collection
            </div>
            {data?.envUrl && (
              <div
                onClick={() => downloadPostmanDoc(data?.envUrl)}
                className="inline-flex items-center gap-2 cursor-pointer bg-[#FF6C37] hover:bg-[#e75b2b] text-white font-semibold text-sm px-4 py-2 rounded-md shadow transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4"
                  />
                </svg>
                Postman environment
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex gap-6">
        <Sidebar
          endPoints={data?.endPoints}
          hasIntro={xpayUser && !!data?.intro}
          activeId={activeId}
          onSelect={handleSidebarSelect}
        />

        <div className="flex-1 min-w-0">
          {xpayUser && <IntroSection intro={data?.intro} />}
          {xpayUser && <AgentPromptSection baseUrl={currentBase} />}

          <div className="space-y-6">
            {data?.endPoints.map((ep, idx) =>
              xpayUser ? (
                <EndpointCard
                  key={idx}
                  id={getEndpointId(idx)}
                  ep={ep}
                  baseUrl={currentBase}
                />
              ) : (
                <LegacyEndpointCard
                  key={idx}
                  id={getEndpointId(idx)}
                  ep={ep}
                  baseUrl={currentBase}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDoc;
